import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { FareRule, Itinerary, Leg } from '~/types';

interface FareRulesProps {
  fareRules: Record<string, FareRule>;
  itinerary: Itinerary;
}

const FareRulesAccordion = ({ fareRules, itinerary }: FareRulesProps) => {
  const fareRulesArray: FareRule[] = Object.values(fareRules);

  const legsArray: Leg[] = [
    ...itinerary.outbound.legs,
    ...(itinerary.inbound ? itinerary.inbound.legs : []),
  ];

  function getLeg(legId: string): Leg | null {
    const legsArrayFilter = legsArray.filter(leg => leg.legId === legId);
    return legsArrayFilter.length ? legsArrayFilter[0] : null;
  }

  return (
    <Box>
      {
        fareRulesArray.map((fareRule: FareRule, index) => {
          const currentLeg = getLeg(fareRule.legId);
          return (
            <Accordion key={index}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center">
                  <Typography variant="subtitle1">
                    {currentLeg?.departure?.city.friendlyName || currentLeg?.departure?.location.friendlyName}{' '}
                    ({currentLeg?.departure?.location.code})
                  </Typography>
                  <ArrowForwardIcon color="action" />
                  <Typography variant="subtitle1">
                    {currentLeg?.arrival?.city.friendlyName || currentLeg?.arrival?.location.friendlyName}{' '}
                    ({currentLeg?.arrival?.location.code}),
                  </Typography>
                  <Typography variant="subtitle1" ml={2}>
                    {currentLeg?.carrier.friendlyName} (Flight {currentLeg?.carrier.code}{currentLeg?.flightNumber})
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  maxHeight: 300,
                  overflowY: 'auto',
                }}
              >
                <Typography variant="body2" color="textSecondary">
                  {fareRule.descriptions.cancellations.fee}
                </Typography>


                {fareRule?.transFormedText?.slice()
                  ?.sort((a, b) => {
                    // Ensure "PENALTIES" comes first
                    if (a.type === 'PENALTIES') return -1;
                    if (b.type === 'PENALTIES') return 1;
                    return 0;
                  })
                  .map((textItem, i) => (
                    textItem.type.toLowerCase() !== 'ticket endorsment' ? <Accordion key={i} sx={{ marginTop: 1 }}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle2">{textItem.type}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          dangerouslySetInnerHTML={{ __html: textItem.description }}
                        />
                      </AccordionDetails>
                    </Accordion> : ''
                  ))}
              </AccordionDetails>
            </Accordion>
          )
        }
        )
      }
    </Box>
  );
};

export default FareRulesAccordion;
